import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(({ palette }) => ({
  detail: {
    color: colors.black,
    textAlign: "right",
  },
  terminated: {
    color: palette.error.main,
  },
}));

export default useStyles;
